export const defaultProps = (isMobile: boolean, width: number) => {
  if (isMobile) return { width };

  return { flex: 1 };
};
